"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var FORM_FACTOR = {
  DESKTOP: 'desktop',
  MOBILE: 'mobile',
  TABLET: 'tablet'
};
var _default = FORM_FACTOR;
exports["default"] = _default;